export const EXPENSE_CATEGORIES = [
  { value: 'Restaurant',    label: 'Restaurant' },
  { value: 'Transport',     label: 'Public Transport' },
  { value: 'Taxi/Uber',     label: 'Taxi / Uber' },
  { value: 'Hébergement',   label: 'Accommodation' },
  { value: 'Fournitures',   label: 'Supplies' },
  { value: 'Autre',         label: 'Other' },
];
